import { Autocomplete, TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { clientsApi } from '../api/clients.api';

interface Props {
  /** Selected client id as a string ('' = none). */
  value: string;
  onChange: (id: string) => void;
  label?: string;
  helperText?: string;
  sx?: SxProps<Theme>;
}

/** Client picker for EPC screens — searchable dropdown (client code — name). */
export function EpcClientSelect({ value, onChange, label = 'Client', helperText, sx }: Props) {
  const { data } = useQuery({ queryKey: ['epc-client-lookup'], queryFn: () => clientsApi.list({ limit: 500, sortBy: 'clientName', sortDir: 'asc' }) });
  const clients = data?.data ?? [];
  const selected = clients.find((c) => String(c.id) === value) ?? null;
  return (
    <Autocomplete
      size="small"
      sx={sx ?? { minWidth: 320 }}
      options={clients}
      getOptionLabel={(c) => `${c.clientCode} — ${c.clientName}`}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      value={selected}
      onChange={(_e, v) => onChange(v ? String(v.id) : '')}
      renderInput={(params) => <TextField {...params} label={label} placeholder="Search client…" helperText={helperText} />}
    />
  );
}
